import { render, staticRenderFns } from "./CLayoutStandard.vue?vue&type=template&id=35a006b3&"
import script from "./CLayoutStandard.ts?vue&type=script&lang=ts&"
export * from "./CLayoutStandard.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports